var path = '/templates/projects.campaigns/views/directives/label_campaign_status.html';
var html = "<div ng-class=statusClass ng-if=!errorMessage>{{text}}</div><div class=text-danger ng-if=errorMessage><i class=\"fa fa-exclamation-circle\"></i> {{errorMessage}}</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.campaigns/views/directives/label_campaign_status.html
// module id = 1395
// module chunks = 0